<template>
  <div class="columns my-0 is-multiline">
    <div class="column is-4">
      <kst-input floating-label load-on-focus
        field="Search" :data="searchData" :catalog="VenSearchCatalog"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import VenSearchCatalog from "../VenSearchCatalog.js";

export default {
  props: {
    searchData: Object
  },
  data: () => ({
    VenSearchCatalog: VenSearchCatalog
  }),
  methods: {
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    }
  }
}
</script>